import React from 'react';
import { titleUI } from 'platform/forms-system/src/js/web-component-patterns';
import { VaAlert } from '@department-of-veterans-affairs/component-library/dist/react-bindings';
import { apportionmentInformationText } from '../../definitions/constants';
import { allAnswersNo } from './helpers';

const importantInfoAlert = (
  <VaAlert status="info" uswds visible>
    <p className="vads-u-margin--0">
      {apportionmentInformationText.importantInfoAlertText}
    </p>
  </VaAlert>
);

export default {
  path: 'important-information',
  title: apportionmentInformationText.importantInformationPageTitle,
  depends: allAnswersNo,
  uiSchema: {
    ...titleUI(apportionmentInformationText.importantInformationPageTitle),
    'view:importantInfoAlert': {
      'ui:field': 'ViewField',
      'ui:description': importantInfoAlert,
    },
  },
  schema: {
    type: 'object',
    properties: {
      'view:importantInfoAlert': { type: 'object', properties: {} },
    },
  },
};
